<template>
  <div>
    <UseAdvancedSettingForm v-model="campaign.useAdvancedSetting" />
    <v-card v-if="campaign.useAdvancedSetting" class="pt-4">
      <v-container>
        <DevicesForm
          v-if="!campaign.advancedSetting.disabledDevices"
          :advanced="campaign.advancedSetting"
          v-model="campaign.advancedSetting.deliveryDevices"
        />
        <InventoriesForm
          v-if="!campaign.advancedSetting.disabledInventories"
          :advanced="campaign.advancedSetting"
          v-model="campaign.advancedSetting.deliveryInventories"
        />
        <InventoryListTargetingForm
          v-if="!campaign.advancedSetting.disabledInventoryListTargeting"
          :inventory-required-lists="inventoryRequiredLists"
          :inventory-optional-lists="inventoryOptionalLists"
          v-model="form.selectedBlackInventoryListOptionalIds"
        />
        <IpAreaSetting
          v-if="!campaign.advancedSetting.disabledIpAreaSetting"
          :form="form"
        />
        <DemographicForm
          v-if="!campaign.advancedSetting.disabledDemographicSetting"
          v-model="form.campaign.advancedSetting.demographicSetting"
          :creative-type="form.campaign.creativeType"
          class="pt-1"
        />
        <WeeklyDeliveryScheduleForm
          v-if="!campaign.advancedSetting.disabledWeeklyDeliverySchedule"
          v-model="campaign.advancedSetting.weeklyDeliverySchedule"
        />
      </v-container>
    </v-card>
  </div>
</template>

<script>
import UseAdvancedSettingForm from '@/components/Shared/Common/FormAdvancedUse'
import DevicesForm from '@/components/Shared/Common/FormAdvancedDevices'
import InventoriesForm from '@/components/Shared/Common/FormAdvancedInventories'
import InventoryListTargetingForm from './CampaignModalPageAdvancedInventoryTargeting'
import DemographicForm from '@/components/Shared/Common/FormAdvancedDemographic'
import WeeklyDeliveryScheduleForm from '@/components/Shared/Common/FormAdvancedWeekly'
import IpAreaSetting from './CampaignModalPageAdvancedIpAreaSetting'

export default {
  components: {
    UseAdvancedSettingForm,
    DevicesForm,
    InventoriesForm,
    InventoryListTargetingForm,
    DemographicForm,
    WeeklyDeliveryScheduleForm,
    IpAreaSetting,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    campaign() {
      return this.form.campaign
    },
    inventoryListTargetings() {
      return this.form.inventoryListTargetings
    },
    inventoryRequiredLists() {
      return this.form.inventoryRequiredLists
    },
    inventoryOptionalLists() {
      return this.form.inventoryOptionalLists
    },
    errorMessage() {
      if (!this.campaign.useAdvancedSetting) {
        return ''
      }
      const messages = []
      if (this.campaign.advancedSetting.isDeviceEmpty) {
        messages.push(
          '配信デバイスが選択されていません。１つ以上選択してください。',
        )
      }
      if (this.campaign.advancedSetting.isInventoryEmpty) {
        messages.push('配信面が選択されていません。１つ以上選択してください。')
      }
      if (this.campaign.advancedSetting.isIncorrectDeviceCombinationWithWeb) {
        messages.push(
          '配信面にWEBブラウザを指定する場合配信デバイスにPCを指定する必要があります。',
        )
      }
      if (
        this.campaign.advancedSetting
          .isIncorrectDeviceCombinationWithMobileInventory
      ) {
        messages.push(
          '配信面にスマホブラウザまたはアプリを指定する場合配信デバイスに' +
            'タブレットもしくはスマートフォンを指定する必要があります。',
        )
      }
      if (this.campaign.advancedSetting.isIncorrectInventoryCombinationWithPC) {
        messages.push(
          '配信デバイスにPCを設定する場合配信面にWEBブラウザを指定する必要があります。',
        )
      }
      if (
        this.campaign.advancedSetting.isIncorrectInventoryCombinationWithMobile
      ) {
        messages.push(
          '配信デバイスにスマートフォンもしくはタブレットを指定する場合配信面にスマホブラウザ' +
            'もしくはアプリのいずれか一つ以上を指定する必要があります。',
        )
      }
      if (this.campaign.advancedSetting.isIpAreaSettingEmpty) {
        messages.push(
          'アクセスエリアを日本全域にするか、都道府県を1つ以上設定してください。',
        )
      }
      return messages.length > 0 ? messages.join('\n\n') : ''
    },
  },
  watch: {
    'campaign.useAdvancedSetting'(newVal) {
      if (newVal) {
        this.form.initInventoryList()
        this.form.setInventoryList()
      }
    },
    'form.selectedBlackInventoryListOptionalIds'(newVal) {
      if (newVal) {
        this.form.setInventoryList()
      }
    },
  },
  created() {
    this.fetchInventoryRequiredLists()
    this.fetchInventoryOptionalLists()
    this.initSelectedBlackInventoryListIds()
  },
  methods: {
    fetchInventoryRequiredLists() {
      this.form.fetchInventoryRequiredLists()
    },
    fetchInventoryOptionalLists() {
      this.form.fetchInventoryOptionalLists()
    },
    initSelectedBlackInventoryListIds() {
      this.form.selectedBlackInventoryListOptionalIds = this.campaign.advancedSetting.inventoryListOptionalIds
    },
  },
}
</script>
